import { render, staticRenderFns } from "./ChecksPorps.vue?vue&type=template&id=1efa160b&"
import script from "./ChecksPorps.vue?vue&type=script&lang=js&"
export * from "./ChecksPorps.vue?vue&type=script&lang=js&"
import style0 from "./ChecksPorps.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports